export default {
  FIR: "fir",
  NO: "no",
  TIPS: "tips",
};
